export default () => ({
  root: {},
  wrap: {
    background: '#ffffff',
    padding: 0,
    maxWidth: '100%',
  },
});
